"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function MagnetThin12Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "Icon", clipPath: "url(#clip0_1821_451)" },
            react_1.default.createElement("path", { id: "Icon_2", fillRule: "evenodd", clipRule: "evenodd", d: "M4.80029 0L7.62872 2.82843L6.92137 3.53578L6.03773 4.41942L4.4465 6.01065C4.05597 6.40118 4.05597 7.03434 4.4465 7.42487C4.83702 7.81539 5.47018 7.81539 5.86071 7.42487L7.45194 5.83363L7.45149 5.83318L9.04248 4.24219L11.8709 7.07061L11.1891 7.75241C11.1809 7.76119 11.1726 7.76986 11.164 7.77842L8.68914 10.2533C6.73651 12.2059 3.57069 12.2059 1.61807 10.2533C-0.334553 8.30067 -0.334553 5.13485 1.61807 3.18222L3.2093 1.59099L4.09294 0.707351L4.80029 0ZM8.5126 6.89429L9.21971 7.6014L7.62848 9.19263C6.26164 10.5595 4.04556 10.5595 2.67873 9.19263C1.31189 7.8258 1.31189 5.60972 2.67873 4.24288L4.26996 2.65165L4.97707 3.35876L3.38584 4.94999C2.40952 5.9263 2.40952 7.50921 3.38584 8.48553C4.36215 9.46184 5.94506 9.46184 6.92137 8.48553L8.5126 6.89429Z", fill: "#D8DADE" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_1821_451" },
                react_1.default.createElement("rect", { width: 12, height: 12, fill: "white" }))));
}
function MagnetThin12(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(MagnetThin12Svg, Object.assign({}, svgProps)));
}
exports.default = MagnetThin12;
//# sourceMappingURL=MagnetThin12.js.map